import { NODE_FLOW } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  edges: "",
  nodes: "",
  selectedElement: {},
  updatedType: "",
  updatedData: {},
  isUpdate: false,
  dtmfInput: [],
  apiResponseKey: [],
  dynamicVariables: [] as any,
  dummyUpdatedDta:{}
};

const nodeFlowSlice = createSlice({
  name: NODE_FLOW,
  initialState,
  reducers: {
    updateNodesAndEdges: (state, { payload }) => {
      state.nodes = payload.nodes;
      state.edges = payload.edges;
    },
    updateSelectedNode: (state, { payload }) => {
      state.selectedElement = payload.selectedElement;
    },
    updateFlow: (state, { payload }) => {
      state.updatedType = payload.updatedType;
      state.updatedData = payload.updatedData;
      state.isUpdate = payload.isUpdate;
    },
    dummyUpdatedDta: (state, { payload }) => {
      state.dummyUpdatedDta = payload.dummyUpdatedDta;
    },
    addDTMFInput: (state, { payload }) => {
      state.dtmfInput = payload.dtmfInput;
    },
    addResponseUrl: (state, { payload }) => {
      state.apiResponseKey = payload.apiResponseKey;
    },
    addDynamicVariable: (state, { payload }) => {
      const allData = state.dynamicVariables.concat(payload);
      const data = new Set(allData);
      state.dynamicVariables = Array.from(data);
    },
    removeDynamicVariable: (state, { payload }) => {
      const index = state?.dynamicVariables?.findIndex((element: any) => element === payload);
      if (index !== -1) {
        state.dynamicVariables?.splice(index, 1);
      }
    },
  },
});

export const NodeFlowActions = nodeFlowSlice.actions;
export default nodeFlowSlice.reducer;
